import * as React from 'react';

import { isPortal } from 'bones/utils/portal/environment';

export const PORTAL_CSRF_TOKEN = {
  value: '',
};

export const refreshPortalCsrfToken = async (): Promise<boolean> => {
  if (isPortal()) {
    return fetch('/api/csrf')
      .then((response) => response.json())
      .then((response) => {
        if (response.csrfToken) {
          PORTAL_CSRF_TOKEN.value = response.csrfToken;
          return true;
        }
        return false;
      })
      .catch((err) => {
        console.error(err);
        return false;
      });
  }
  return false;
};

export const usePortalCsrfToken = () => {
  React.useEffect(() => {
    refreshPortalCsrfToken();
  }, []);
};

export const fetchWithCsrfTokenRefresh = async (
  input: string,
  init: RequestInit
) => {
  const initWithToken: RequestInit = {
    ...init,
    headers: { ...init.headers, 'X-CSRFToken': PORTAL_CSRF_TOKEN.value },
  };

  let response = await fetch(input, initWithToken);
  if (response.status === 403) {
    const didRefresh = await refreshPortalCsrfToken();
    if (didRefresh) {
      response = await fetch(input, initWithToken);
    }
  }

  return response;
};
